export const CLOSED = 'closed';
export const CLOSING = 'closing';
export const CONNECTED = 'connected';
export const CONNECTING = 'connecting';
export const DISCONNECTED = 'disconnected';
export const FAILED = 'failed';
export const INITIALIZED = 'initialized';
export const SUSPENDED = 'suspended';